import {Box, Grid, Pillar} from '@primer/react-brand/esm'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import type {IconItem} from '../../types'
import {renderPillarHeading, renderWithoutParagraphs} from '../../utils'
import baseStyles from '../../styles/base.module.css'

export type FlexSuiteIntroPillarsProps = {
  introPillars?: IconItem[]
  promoteFirstHeading?: boolean
}

export function FlexSuiteIntroPillars({introPillars, promoteFirstHeading = false}: FlexSuiteIntroPillarsProps) {
  if (!introPillars || introPillars.length === 0) return null

  const firstHeadingIndex = introPillars.findIndex(item => Boolean(item.fields.heading))

  return (
    <Box className={baseStyles.greenBorderBottom}>
      <Grid columnGap="none" className={baseStyles.gridContent}>
        {introPillars.map((item, index) => {
          const IconComponent = item.fields.icon ? getPrimerIcon(item.fields.icon) : null
          return (
            /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
            <Grid.Column key={item.sys.id} span={{medium: 4}} className="gridColumn">
              <Box
                className={baseStyles.cardGridItem}
                padding={{narrow: 24, regular: 40, wide: 64}}
                borderWidth="thin"
                borderColor="muted"
              >
                <Pillar>
                  {IconComponent ? <Pillar.Icon icon={<IconComponent />} /> : null}
                  {item.fields.heading && (
                    <Pillar.Heading as={index === firstHeadingIndex && promoteFirstHeading ? 'h2' : 'h3'} size="6">
                      {renderPillarHeading(item.fields.heading)}
                    </Pillar.Heading>
                  )}
                  {item.fields.description && (
                    <Pillar.Description>{renderWithoutParagraphs(item.fields.description)}</Pillar.Description>
                  )}
                </Pillar>
              </Box>
            </Grid.Column>
          )
        })}
      </Grid>
    </Box>
  )
}
